import {Navigate, useLocation} from 'react-router-dom';
import {useAuth} from './context/AuthContext';

type Role = 'ADMIN' | 'EDITOR' | (string & {});
const norm = (xs: string[] = []) => xs.map(r => r.replace(/^ROLE_/i, '').toUpperCase());
const hasAny = (userRoles: string[] | undefined, allowed: string[]) =>
    norm(userRoles).some(r => norm(allowed).includes(r));

export function RoleRoute({children, allowed}: { children: []; allowed: Role[] }) {
    const {user, isReady} = useAuth();
    const location = useLocation();

    if (!isReady) return null; // or a spinner/skeleton

    if (!user) {
        return <Navigate to="/login" replace state={{from: location}}/>;
    }
    if (!hasAny(user.roles, allowed)) {
        return <Navigate to="/" replace/>; // or a 403 page
    }
    return children;
}
